<template>
	<popup-view class="context-popup-view" v-bind="$attrs" @close="$emit('close')">
		<div class="search">
			<input ref="input" type="text" v-model="search" />
		</div>
		<div v-show="_results.length > 0" class="results">
			<div class="item" v-for="(r, i) in _results" :key="i" @click="select(r.type, r.id, r.label)">{{ r.label }}</div>
		</div>
	</popup-view>
</template>

<script>
	//import merge from '../functions/merge'

	export default {
		data() {
			return {
				search: ''
			};
		},
		props: {
			resources: {
				type: Array,
				default() {
					return [];
				}
			},
			callback: {
				type: Function,
				default() {
					return function () {};
				}
			}
		},
		computed: {
			_results() {
				var c = 0;
				var r = [];
				var src = this.search.toLowerCase();

				for (var i = 0; i < this.resources.length && c < 5; ++i) {
					var res = this.resources[i];

					if (res.label.toLowerCase().indexOf(src) > -1) {
						r.push(res);
						c++;
					}
				}

				return r;
			}
		},
		methods: {
			select(type, id, label) {
				this.callback(type, id, label);
				this.$emit('close');
			}
		},
		mounted() {
			this.$refs.input.focus();
		}
	}
</script>

<style lang="scss" scoped>
	.context-popup-view {
		& > .search {
			& > input {
				height: 30px;
				line-height: 30px;
				padding: 0 10px 0 10px;
			}
		}

		& > .results {
			border-top: 1px solid #CECECE;
			
			& > .item {
				padding: 10px 40px 10px 20px;
				font-size: 12px;
				cursor: pointer;

				&:hover {
					background-color: rgb(248, 246, 246);
				}
			}
		}
	}
</style>